import { TableAction } from "../../../../components/ModularDataTable"



type ActionsFactoryParams = {
  navigate: (path: string) => void

}

export function createActionsPluginSpace({navigate}:ActionsFactoryParams): any[] {


    const actions: TableAction[] = [
        {
            icon: 'fas fa-pen',
            label: 'Adicionar Permissões',
            action: (item: any) => navigate(`/swagger_permission/pluginspace/${item.id}`),
        },
    ]
    return actions
}